import React from 'react';
// import DashboardPage from '../containers/dashboard';
// import results from '../data/votes-summary.json';
import HoldingPage from '../containers/holding-page';

// const IndexPage = () => <DashboardPage results={results} />;
const IndexPage = () => <HoldingPage />;

export default IndexPage;
